import { cx } from "class-variance-authority";

export default function IconButton({
    icon: Icon,          // The icon component to render (e.g., FaTrash, MdSettings)
    iconClassName = 'arrow',
    ariaLabel,           // Crucial for screen readers when there is no text
    variant = 'default', // default, primary, danger, outline
    size = '',         // sm, md, lg
    className = '',
    onClick,
    disabled = false,
    ...props             // Captures any other standard button attributes
}) {
    // Base classes for a centered, circular icon button
    const baseStyles = 'inline-flex items-center justify-center rounded-full transition-colors disabled:opacity-50 disabled:pointer-events-none';

    // Style variants
    const variants = {
        default: '',
        filled: 'bg-blue-600 text-white hover:bg-blue-700 active:bg-blue-800',
        outlined: 'border border-gray-300 text-gray-700 bg-transparent hover:bg-gray-50 active:bg-gray-100',
        ghost: 'text-gray-600 hover:bg-gray-100 active:bg-gray-200',
    };

    // Size constraints
    const sizes = {
        sm: 'p-1.5 text-sm',
        md: 'p-2 text-base',
        lg: 'p-3 text-lg',
    };

    return (
        <button
            type="button"
            className={cx(baseStyles, variants[variant], sizes[size], className)}
            onClick={onClick}
            disabled={disabled}
            aria-label={ariaLabel}
            {...props}
        >
            {Icon && <Icon className={iconClassName} />}
        </button>
    );
}
